import moment from 'moment';
// daysAgo returns the number of days ago that a date was compared to the current time
// optional now date for comparison against.
export const daysAgo = (then, now = new Date()) => {
    return Math.floor(moment.duration(moment(now).diff(then)).asDays());
};
export const hoursAgo = (then, now = new Date()) => {
    return Math.floor(moment.duration(moment(now).diff(then)).asHours());
};
export const daysString = (then, now = new Date()) => {
    if (then === undefined)
        return '-';
    const days = daysAgo(then, now);
    if (days == 0) {
        return 'today';
    }
    const unit = Math.abs(days) === 1 ? 'day' : 'days';
    const noun = days > 0 ? 'ago' : 'remaining';
    return `${Math.abs(days).toLocaleString()} ${unit} ${noun}`;
};
export const timeString = (then, now = new Date()) => {
    if (!then)
        return 'unknown';
    const days = daysAgo(then, now);
    if (days <= 2) {
        const hours = hoursAgo(then, now);
        const noun = hours < 0 ? 'remaining' : 'ago';
        const unit = Math.abs(hours) === 1 ? 'hour' : 'hours';
        return `${Math.abs(hours)} ${unit} ${noun}`;
    }
    return daysString(then, now);
};
